import React, { Component } from "react";
import { ChevronLeft } from "react-feather";
import error404 from "assets/img/error404.png";

class Error404 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="flex justify-center items-center  top-vh-pg">
        <div>
          <img src={error404} alt="error-404" className="error-img-w" />

          <div className="mt-8">
            <p className="fsize28  text-black font-bold">
              Oops! Page Not Found
            </p>
            <div className="flex mt-4 justifiy-center items-center">
              <ChevronLeft className="textE77817" />
              <p className="textE77817 fsize18 font-bold">Go Back</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Error404;
